import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AvisosService } from 'src/app/services/avisos.service';
import { FormsModule } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';

declare var $: any;

@Component({
    selector: 'app-modal-aviso',
    templateUrl: './modal-aviso.component.html',
    styleUrls: ['./modal-aviso.component.css'],
    imports: [FormsModule]
})
export class ModalAvisoComponent implements OnInit {

  aviso: any;
  arquivos: any[] = [];
  aceito: boolean = false;

  @Input() modalID: string = "modalAviso";
  @Output() onModalClose = new EventEmitter();

  constructor(private avisosService: AvisosService, private utilService: UtilService) {

  }

  ngOnInit() {
  }

  init(aviso: any){

    this.aceito = false;
    this.aviso = aviso;

    this.arquivos = [];

    if(this.aviso.COD_ARQ_GRUPO!=null){
      this.listarArquivos(this.aviso.COD_ARQ_GRUPO);
    }

    this.marcarComoLido();
  }

  listarArquivos(codArqGrupo){

    this.avisosService
        .ListarArquivos(codArqGrupo)
        .subscribe(
          (res: any) => {

            this.arquivos = res;
          }
        )
  }

  gravarAceite(codAviAviso: number){

    if(this.aceito){

      this.avisosService
          .GravarAceite(codAviAviso)
          .subscribe(
            (res: any) => {
              this.fecharModal();
            }
          )

    }
  }

  marcarComoLido(){

    this.avisosService
        .MarcarComoLido(this.aviso.COD_AVI_AVISO)
        .subscribe(
          (res: any) => {

          }
        )

  }

  fecharModal(){
    $('#'+this.modalID).modal('hide');
    this.onModalClose.emit(true);
  }

  download(hashCordArq: string, nome: string){

      this.avisosService
          .DownloadArquivo(hashCordArq)
          .subscribe(fileData => this.utilService.salvarArquivo(fileData, nome));

  }

}
